/**
    Author: Suneel Singh - suneel.singh@enabledata.com
    Purpose: All application constants declared here
    Date: June 02, 2020
**/
import packageJson from '../../package.json';
let ssologinURL = '';
let ssologoutURL = '';
let azureloginURL = '';
const stage = process.env.REACT_APP_SENTRY_ENVIRONMENT;
if(stage !== 'pacheck'){
  ssologinURL = process.env.REACT_APP_SSO_LOGIN_URL + `redirect_uri=https://${stage}-${packageJson.appname}.itilitihealth.com/okta/ssologin&logout_uri=https://${stage}-${packageJson.appname}.itilitihealth.com/login`;
  ssologoutURL = process.env.REACT_APP_SSO_LOGOUT_URL + `https://${stage}-${packageJson.appname}.itilitihealth.com/login`;
  azureloginURL = process.env.REACT_APP_AZURE_LOGIN_URL + `redirect_uri=https://${stage}-${packageJson.appname}.itilitihealth.com/azure/ssologin&logout_uri=https://${stage}-${packageJson.appname}.itilitihealth.com/login`;
} else {
  ssologinURL= process.env.REACT_APP_SSO_LOGIN_URL + `redirect_uri=https://${packageJson.appname}.itilitihealth.com/okta/ssologin&logout_uri=https://${packageJson.appname}.itilitihealth.com/login`;
  ssologoutURL = process.env.REACT_APP_SSO_LOGOUT_URL + `https://${packageJson.appname}.itilitihealth.com/login`;
  azureloginURL = process.env.REACT_APP_AZURE_LOGIN_URL + `redirect_uri=https://${packageJson.appname}.itilitihealth.com/azure/ssologin&logout_uri=https://${packageJson.appname}.itilitihealth.com/login`;
}

export const currentUserEntity = {
  tenantAdminOrgsRole: 'ROLES#a057554e-777f-44f9-beb6-dfd0d9deaf26',
  platformOperator: 'platform operator',
  platformAdminTitle: 'platform administrator',
  tenantAdminTitle: 'tenant administrator',
  tenantManagerTitle: 'tenant manager',
  tenantUser: 'tenant user',
  policyUser: 'policy user',
  policyOperator: 'policy operator',
  policyManager: 'policy manager',
  tenantOperator: 'tenant operator',
  tenantAnalyst: 'tenant analyst',
};
export const hasReportsMenuAccess = [
  currentUserEntity.platformAdminTitle,
  currentUserEntity.tenantAdminTitle,
  currentUserEntity.tenantManagerTitle,
  currentUserEntity.policyUser,
  currentUserEntity.policyManager,
  currentUserEntity.tenantAnalyst,
];
/* export const hasEventsMenuAccess = [
  currentUserEntity.tenantAdminTitle,
  currentUserEntity.tenantManagerTitle,
  currentUserEntity.policyUser,
  currentUserEntity.policyManager,
  currentUserEntity.policyOperator,
]; */
export const customPATypeLables = {
  y: 'REQUIRED',
  u: 'UNDETERMINED',
  n: 'NOT REQUIRED',
};

export const ROLE_POLICY_MANAGER = 'ROLES#7d4fb81f-6c9b-4386-87d4-73505a5d069d';
export const ROLE_POLICY_OPERATOR =
  'ROLES#7692e4b2-b86c-47fd-8399-92cb890aa3e1';

export const globalPageLimit = {
  PROCEDURE_LIMIT: 20000,
  POLICY_LIMIT: 50000,
  GROUP_LIMIT: 50000,
  LOB_LIMIT: 50000,
  INSTRUCTION_LIMIT: 50000,
  PROGRAM_LIMIT: 50000,
  ORGS_LIMIT: 50000,
  CUSTOM_TYPE_LIMIT: 10000,
  USER_LIMIT: 50000,
  CLIENT_LIMIT: 50000,
};

export const globalAssoSearchListingTypeEntity = {
  clients: 'clients',
  groups: 'groups',
  procedures: 'procedures',
  policies: 'policies',
  instructions: 'instructions',
  programs: 'programs',
  businesslines: 'businesslines',
  policies_version: 'policies_version',
  diagnostic_codes: "diagnostic_codes",
  services: "services",
  import: "import",
  users:'users',
  standard_report:"standard_report",
  report_builder:"report_builder"
};

export const globalRecordTypeEntity = {
  client: 'client',
  policy: 'policy',
  group: 'group',
  procedure: 'procedure',
  instructions: 'instructions',
  business: 'business',
  program: 'program',
  PROCEDURE: 'PROCEDURE',
};

export const globalPageTypeEntity = {
  view: 'view',
  edit: 'edit',
  add: 'add',
  read: 'read',
  delete: 'delete',
  clone: 'clone',
  deactivate: 'deactivate',
};

export const globalDateEntity = {
  siteHeaderTitle: 'itiliti Health',
  footerText: 'Copyright 2023 Itiliti Health. All Rights Reserved',
  primaryColor: '#42b883',
  primaryFontColor: '#ffffff',
  primaryFontFamily: 'Alatsi, sans-serif',
  secondaryFontFamily: 'Abel, sans-serif',
  backgroundColor: '#ffffff',
  dateFormatPost: 'YYYY-MM-DD',
  dateTimeFormatPost: 'YYYY-MM-DDT00:00:00',
  brandingLogoSize: 3145728,
  dateFormat: 'MM-DD-YYYY',
  dateTimeFormat: 'MM-DD-YYYY h:mm:ss',
  datePickerFormat: 'MM-DD-YYYY',
  timePostfix: 'T00:00:00',
  dateTimeFormatWith24Hour: 'MM-DD-YYYY HH:mm:ss',
  defaultTimezone: 'cst',
  displayDateFormat1: 'MMM DD, YYYY',
};

export const ssoLoginEntity = {
  ssoLoginUrl: ssologinURL,
  ssoLogoutUrl: ssologoutURL,
  azureLoginUrl: azureloginURL,
  azureLogoutUrl: process.env.REACT_APP_AZURE_LOGOUT_URL,
};
export const entityConfigValues = {
  REQUIRED: 'required',
  NOT_REQUIRED: 'not required',
};

export const entityMetaFields = {
  groups: {
    client_id: ['Required', 'Optional', 'Hidden'],
    lob_id: ['Required', 'Optional', 'Hidden'],
  },
};
export const entityMetaFieldConfig = {
  lob_id: {
    displayName: 'Business Lines',
    id: 'lob_id',
  },
  client_id: {
    displayName: 'Clients',
    id: 'client_id',
  },
};
export const ProcedureRecordTypeList = [
  'CPT',
  'CDT',
  'HCPC',
  'HCPCS',
  'UB-04 Rev',
];
export const DatepickerStartDate = '1900-01-01';
export const GlobalPrimaryLookupEntities = {
  groups: {
    label: 'Member Group Number',
    entity_type: 'groups',
  },
  members: {
    label: 'Member Number',
    entity_type: 'members',
  },
};
export const mainEntities = {
  transactions: [
    'entity-transactions-transaction_id',
    'entity-transactions-group_number',
    'entity-transactions-date_of_service',
    'entity-transactions-submission_date',
    'entity-transactions-procedure_codes',
    'entity-transactions-external_user_type',
    'entity-transactions-external_user_id',
    'entity-transactions-source',
  ],
  members: [
    'entity-members-subscriber_id',
    'entity-members-effectivedate',
    'entity-members-inactivedate',
    'entity-members-plan_id',
  ],
  groups: [
    'entity-groups-record_number',
    'entity-groups-title',
    'entity-groups-client_id',
    'entity-groups-current_status',
    'entity-groups-prior_auth_exumption',
    'entity-groups-effectivedate',
    'entity-groups-inactivedate',
  ],
  groups_programs: [
    'entity-groups-record_number',
    'entity-groups-title',
    'entity-groups-client_id',
    'entity-groups-current_status',
    'entity-groups-prior_auth_exumption',
    'entity-groups-effectivedate',
    'entity-groups-inactivedate',
    'asso-programs-shortname',
    'asso-programs-title',
    'asso-programs-sourcing',
    'asso-programs-current_status',
    'asso-programs-optin_status',
    'asso-programs-effectivedate',
    'asso-programs-inactivedate',
  ],
  groups_businesslines: [
    'entity-groups-record_number',
    'entity-groups-title',
    'entity-groups-client_id',
    'entity-groups-current_status',
    'entity-groups-prior_auth_exumption',
    'entity-groups-effectivedate',
    'entity-groups-inactivedate',
    'asso-businesslines-title',
    'asso-businesslines-current_status',
    'asso-businesslines-prior_auth_exumption',
    'asso-businesslines-effectivedate',
    'asso-businesslines-inactivedate',
  ],
  groups_clients: [
    'entity-groups-record_number',
    'entity-groups-title',
    'entity-groups-client_id',
    'entity-groups-current_status',
    'entity-groups-prior_auth_exumption',
    'entity-groups-effectivedate',
    'entity-groups-inactivedate',
    'asso-clients-title',
    'asso-clients-current_status',
    'asso-clients-prior_auth_exumption',
    'asso-clients-effectivedate',
    'asso-clients-inactivedate',
  ],
  groups_instructions: [
    'entity-groups-record_number',
    'entity-groups-title',
    'entity-groups-client_id',
    'entity-groups-current_status',
    'entity-groups-prior_auth_exumption',
    'entity-groups-effectivedate',
    'entity-groups-inactivedate',
    'asso-instructions-shortname',
    'asso-instructions-title',
    'asso-instructions-record_type',
    'asso-instructions-current_status',
    'asso-instructions-effectivedate',
    'asso-instructions-inactivedate',
  ],
  groups_procedures: [
    'entity-groups-record_number',
    'entity-groups-title',
    'entity-groups-client_id',
    'entity-groups-current_status',
    'entity-groups-prior_auth_exumption',
    'entity-groups-effectivedate',
    'entity-groups-inactivedate',
    'asso-procedures-record_number',
    'asso-procedures-title',
    'asso-procedures-record_type',
    'asso-procedures-category',
    'asso-procedures-current_status',
    'asso-procedures-pa_status',
    'asso-procedures-effectivedate',
    'asso-procedures-inactivedate',
  ],
  policies: [
    'entity-policies-shortname',
    'entity-policies-title',
    'entity-policies-record_type',
    'entity-policies-current_status',
    'entity-policies-lob_title',
  ],
  policies_policies_version: [
    'entity-policies-shortname',
    'entity-policies-title',
    'entity-policies-record_type',
    'entity-policies-current_status',
    'entity-policies-lob_title',
    'asso-policies_version-shortname',
    'asso-policies_version-version',
    'asso-policies_version-effectivedate',
    'asso-policies_version-inactivedate',
  ],
  policies_instructions: [
    'entity-policies-shortname',
    'entity-policies-title',
    'entity-policies-record_type',
    'entity-policies-current_status',
    'entity-policies-lob_title',
    'asso-instructions-shortname',
    'asso-instructions-title',
    'asso-instructions-record_type',
    'asso-instructions-current_status',
    'asso-instructions-effectivedate',
    'asso-instructions-inactivedate',
  ],
  policies_procedures: [
    'entity-policies-shortname',
    'entity-policies-title',
    'entity-policies-record_type',
    'entity-policies-current_status',
    'entity-policies-lob_title',
    'asso-procedures-record_number',
    'asso-procedures-title',
    'asso-procedures-record_type',
    'asso-procedures-category',
    'asso-procedures-current_status',
    'asso-procedures-pa_status',
    'asso-procedures-effectivedate',
    'asso-procedures-inactivedate',
  ],
  businesslines: [
    'entity-businesslines-title',
    'entity-businesslines-current_status',
    'entity-businesslines-prior_auth_exumption',
    'entity-businesslines-effectivedate',
    'entity-businesslines-inactivedate',
  ],
  businesslines_programs: [
    'entity-businesslines-title',
    'entity-businesslines-current_status',
    'entity-businesslines-prior_auth_exumption',
    'entity-businesslines-effectivedate',
    'entity-businesslines-inactivedate',
    'asso-programs-shortname',
    'asso-programs-title',
    'asso-programs-sourcing',
    'asso-programs-current_status',
    'asso-programs-optin_status',
    'asso-programs-effectivedate',
    'asso-programs-inactivedate',
  ],
  businesslines_groups: [
    'entity-businesslines-title',
    'entity-businesslines-current_status',
    'entity-businesslines-prior_auth_exumption',
    'entity-businesslines-effectivedate',
    'entity-businesslines-inactivedate',
    'asso-groups-record_number',
    'asso-groups-title',
    'asso-groups-client_id',
    'asso-groups-current_status',
    'asso-groups-effectivedate',
    'asso-groups-inactivedate',
  ],
  businesslines_instructions: [
    'entity-businesslines-title',
    'entity-businesslines-current_status',
    'entity-businesslines-prior_auth_exumption',
    'entity-businesslines-effectivedate',
    'entity-businesslines-inactivedate',
    'asso-instructions-shortname',
    'asso-instructions-title',
    'asso-instructions-record_type',
    'asso-instructions-current_status',
    'asso-instructions-effectivedate',
    'asso-instructions-inactivedate',
  ],
  businesslines_procedures: [
    'entity-businesslines-title',
    'entity-businesslines-current_status',
    'entity-businesslines-prior_auth_exumption',
    'entity-businesslines-effectivedate',
    'entity-businesslines-inactivedate',
    'asso-procedures-record_number',
    'asso-procedures-title',
    'asso-procedures-record_type',
    'asso-procedures-category',
    'asso-procedures-current_status',
    'asso-procedures-pa_status',
    'asso-procedures-effectivedate',
    'asso-procedures-inactivedate',
  ],
  clients: [
    'entity-clients-record_number',
    'entity-clients-title',
    'entity-clients-current_status',
    'entity-clients-prior_auth_exumption',
    'entity-clients-effectivedate',
    'entity-clients-inactivedate',
  ],
  clients_programs: [
    'entity-clients-record_number',
    'entity-clients-title',
    'entity-clients-current_status',
    'entity-clients-prior_auth_exumption',
    'entity-clients-effectivedate',
    'entity-clients-inactivedate',
    'asso-programs-shortname',
    'asso-programs-title',
    'asso-programs-sourcing',
    'asso-programs-current_status',
    'asso-programs-optin_status',
    'asso-programs-effectivedate',
    'asso-programs-inactivedate',
  ],
  clients_groups: [
    'entity-clients-record_number',
    'entity-clients-title',
    'entity-clients-current_status',
    'entity-clients-prior_auth_exumption',
    'entity-clients-effectivedate',
    'entity-clients-inactivedate',
    'asso-groups-record_number',
    'asso-groups-title',
    'asso-groups-client_id',
    'asso-groups-current_status',
    'asso-groups-effectivedate',
    'asso-groups-inactivedate',
  ],
  clients_instructions: [
    'entity-clients-record_number',
    'entity-clients-title',
    'entity-clients-current_status',
    'entity-clients-prior_auth_exumption',
    'entity-clients-effectivedate',
    'entity-clients-inactivedate',
    'asso-instructions-shortname',
    'asso-instructions-title',
    'asso-instructions-record_type',
    'asso-instructions-current_status',
    'asso-instructions-effectivedate',
    'asso-instructions-inactivedate',
  ],
  clients_procedures: [
    'entity-clients-record_number',
    'entity-clients-title',
    'entity-clients-current_status',
    'entity-clients-prior_auth_exumption',
    'entity-clients-effectivedate',
    'entity-clients-inactivedate',
    'asso-procedures-record_number',
    'asso-procedures-title',
    'asso-procedures-record_type',
    'asso-procedures-category',
    'asso-procedures-current_status',
    'asso-procedures-pa_status',
    'asso-procedures-effectivedate',
    'asso-procedures-inactivedate',
  ],
  programs: [
    'entity-programs-shortname',
    'entity-programs-title',
    'entity-programs-sourcing',
    'entity-programs-current_status',
    'entity-programs-effectivedate',
    'entity-programs-inactivedate',
  ],
  programs_businesslines: [
    'entity-programs-shortname',
    'entity-programs-title',
    'entity-programs-sourcing',
    'entity-programs-current_status',
    'entity-programs-effectivedate',
    'entity-programs-inactivedate',
    'asso-businesslines-title',
    'asso-businesslines-current_status',
    'asso-businesslines-optin_status',
    'asso-businesslines-effectivedate',
    'asso-businesslines-inactivedate',
  ],
  programs_clients: [
    'entity-programs-shortname',
    'entity-programs-title',
    'entity-programs-sourcing',
    'entity-programs-current_status',
    'entity-programs-effectivedate',
    'entity-programs-inactivedate',
    'asso-clients-title',
    'asso-clients-current_status',
    'asso-clients-prior_auth_exumption',
    'asso-clients-optin_status',
    'asso-clients-effectivedate',
    'asso-clients-inactivedate',
  ],
  programs_groups: [
    'entity-programs-shortname',
    'entity-programs-title',
    'entity-programs-sourcing',
    'entity-programs-current_status',
    'entity-programs-effectivedate',
    'entity-programs-inactivedate',
    'asso-groups-record_number',
    'asso-groups-title',
    'asso-groups-client_id',
    'asso-groups-current_status',
    'asso-groups-optin_status',
    'asso-groups-effectivedate',
    'asso-groups-inactivedate',
  ],
  programs_instructions: [
    'entity-programs-shortname',
    'entity-programs-title',
    'entity-programs-sourcing',
    'entity-programs-current_status',
    'entity-programs-effectivedate',
    'entity-programs-inactivedate',
    'asso-instructions-shortname',
    'asso-instructions-title',
    'asso-instructions-record_type',
    'asso-instructions-current_status',
    'asso-instructions-effectivedate',
    'asso-instructions-inactivedate',
  ],
  programs_procedures: [
    'entity-programs-shortname',
    'entity-programs-title',
    'entity-programs-sourcing',
    'entity-programs-current_status',
    'entity-programs-effectivedate',
    'entity-programs-inactivedate',
    'asso-procedures-record_number',
    'asso-procedures-title',
    'asso-procedures-record_type',
    'asso-procedures-category',
    'asso-procedures-current_status',
    'asso-procedures-pa_status',
    'asso-procedures-dual_managed',
    'asso-procedures-effectivedate',
    'asso-procedures-inactivedate',
  ],
  instructions: [
    'entity-instructions-shortname',
    'entity-instructions-title',
    'entity-instructions-record_type',
    'entity-instructions-current_status',
    'entity-instructions-effectivedate',
    'entity-instructions-inactivedate',
  ],
  instructions_programs: [
    'entity-instructions-shortname',
    'entity-instructions-title',
    'entity-instructions-record_type',
    'entity-instructions-current_status',
    'entity-instructions-effectivedate',
    'entity-instructions-inactivedate',
    'asso-programs-shortname',
    'asso-programs-title',
    'asso-programs-sourcing',
    'asso-programs-current_status',
    'asso-programs-clinical_criteria',
    'asso-programs-effectivedate',
    'asso-programs-inactivedate',
  ],
  instructions_businesslines: [
    'entity-instructions-shortname',
    'entity-instructions-title',
    'entity-instructions-record_type',
    'entity-instructions-current_status',
    'entity-instructions-effectivedate',
    'entity-instructions-inactivedate',
    'asso-businesslines-title',
    'asso-businesslines-current_status',
    'asso-businesslines-prior_auth_exumption',
    'asso-businesslines-effectivedate',
    'asso-businesslines-inactivedate',
  ],
  instructions_clients: [
    'entity-instructions-shortname',
    'entity-instructions-title',
    'entity-instructions-record_type',
    'entity-instructions-current_status',
    'entity-instructions-effectivedate',
    'entity-instructions-inactivedate',
    'asso-clients-title',
    'asso-clients-current_status',
    'asso-clients-prior_auth_exumption',
    'asso-clients-effectivedate',
    'asso-clients-inactivedate',
  ],
  instructions_groups: [
    'entity-instructions-shortname',
    'entity-instructions-title',
    'entity-instructions-record_type',
    'entity-instructions-current_status',
    'entity-instructions-effectivedate',
    'entity-instructions-inactivedate',
    'asso-groups-record_number',
    'asso-groups-title',
    'asso-groups-client_id',
    'asso-groups-current_status',
    'asso-groups-prior_auth_exumption',
    'asso-groups-effectivedate',
    'asso-groups-inactivedate',
  ],
  instructions_policies: [
    'entity-instructions-shortname',
    'entity-instructions-title',
    'entity-instructions-record_type',
    'entity-instructions-current_status',
    'entity-instructions-effectivedate',
    'entity-instructions-inactivedate',
    'asso-policies-shortname',
    'asso-policies-title',
    'asso-policies-record_type',
    'asso-policies-current_status',
    'asso-policies-effectivedate',
    'asso-policies-inactivedate',
  ],
  procedures: [
    'entity-procedures-record_number',
    'entity-procedures-title',
    'entity-procedures-record_type',
    'entity-procedures-category',
    'entity-procedures-current_status',
  ],
  procedures_programs: [
    'entity-procedures-record_number',
    'entity-procedures-title',
    'entity-procedures-record_type',
    'entity-procedures-category',
    'entity-procedures-current_status',
    'asso-programs-shortname',
    'asso-programs-title',
    'asso-programs-sourcing',
    'asso-programs-current_status',
    'asso-programs-pa_status',
    'asso-programs-dual_managed',
    'asso-programs-effectivedate',
    'asso-programs-inactivedate',
  ],
  procedures_businesslines: [
    'entity-procedures-record_number',
    'entity-procedures-title',
    'entity-procedures-record_type',
    'entity-procedures-category',
    'entity-procedures-current_status',
    'asso-businesslines-title',
    'asso-businesslines-current_status',
    'asso-businesslines-effectivedate',
    'asso-businesslines-inactivedate',
  ],
  procedures_clients: [
    'entity-procedures-record_number',
    'entity-procedures-title',
    'entity-procedures-record_type',
    'entity-procedures-category',
    'entity-procedures-current_status',
    'asso-clients-title',
    'asso-clients-current_status',
    'asso-clients-prior_auth_exumption',
    'asso-clients-effectivedate',
    'asso-clients-inactivedate',
  ],
  procedures_groups: [
    'entity-procedures-record_number',
    'entity-procedures-title',
    'entity-procedures-record_type',
    'entity-procedures-category',
    'entity-procedures-current_status',
    'asso-groups-record_number',
    'asso-groups-title',
    'asso-groups-client_id',
    'asso-groups-current_status',
    'asso-groups-pa_status',
    'asso-groups-effectivedate',
    'asso-groups-inactivedate',
  ],
  procedures_policies: [
    'entity-procedures-record_number',
    'entity-procedures-title',
    'entity-procedures-record_type',
    'entity-procedures-category',
    'entity-procedures-current_status',
    'asso-policies-shortname',
    'asso-policies-title',
    'asso-policies-record_type',
    'asso-policies-current_status',
    'asso-policies-pa_status',
    'asso-policies-effectivedate',
    'asso-policies-inactivedate',
  ],
};

export const PACKAGES = {
  legacy: 'package_legacy_version_support',
  base: 'package_base',
  policy_management: 'package_policy_management',
  pa_routing: 'package_pa_routing'
};

export const DEFAULT_PACKAGES = [{
    label: 'Base Package',
    value: 'package_base',
  }];

export const PACKAGE_LIST = [
  {
    label: 'Base Package',
    value: 'package_base',
  },
  {
    label: 'Policy Management Module',
    value: 'package_policy_management',
  },
  {
    label: 'Legacy Support for Policy Management',
    value: 'package_legacy_version_support',
  },
  {
    label: 'PA Routing',
    value: 'package_pa_routing',
  },
  {
    label: 'Front Runner Support',
    value: 'package_frontrunner',
  },
];

export const IDLE_SESSION_SETTING = {
  timeout: 1000 * 60 * 55, // Show alert after these interval (milliseconds)
  idleSessionTimerInterval: 1000 * 3,
  bufferTime: 1000 * 60 * 5, // Countdown after popup is displayed and before a use is auto logged out if no action is taken (milliseconds)
  bufferTimeInterval:  1000  // The interval for running the buffer time check (milliseconds)
}
  

export const DEFAULT_BREADCRUMBS = [
  {
    title: "Home",
    link: "/",
    // isExternalUrl: true
  },
]

export const PAGINATION_DEFAULT_LIMIT = 10;